<template>
    <Modal
        @close="close"
        title="Kreator kodów"
        @submit="submit"
        :actions="modalActions"
    >
        <EditSection
            title="Promo"
            :actions="sectionActions"
            accent="apple"
            :errors="errors"
            :sections="promoSection"
            ref="promoSection"
            section="promoSection"
            @action="actionEmitted"
        />
    </Modal>
</template>
<script>
export default {
    props: {
        selectedPromo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            loading: false,
            errors: new this.$Errors(),
            promoSection: {
                discount: {
                    required: true,
                    title: 'Zniżka (%)',
                    value: 0,
                    type: 'number-input',
                    key: 'discount',
                    color: '#FFF',
                    size: 1
                },
                is_active: {
                    title: 'Aktywny?',
                    value: false,
                    options: {
                        false: 'Nie',
                        true: 'Tak'
                    },
                    type: 'switch',
                    key: 'is_active',
                    color: '#FFF',
                    size: 1
                },
                products: {
                    required: true,
                    title: 'Produkt',
                    value: '',
                    type: 'single-select',
                    search: true,
                    options: this.getProductOptions(),
                    key: 'products',
                    color: '#FFF'
                }
            }
        }
    },
    computed: {
        editing() {
            return this.selectedPromo.token != undefined
        },
        sectionActions() {
            if (this.editing) {
                return [
                    {
                        display: 'Usuń kod',
                        action: 'delete',
                        color: 'red',
                        materialIcon: 'delete'
                    },
                    {
                        display: 'Kopiuj kod',
                        action: 'copy',
                        color: 'apple',
                        materialIcon: 'content_copy'
                    }
                ]
            }
        },
        modalActions() {
            return [
                {
                    color: 'apple',
                    action: 'submit',
                    display: 'SAVE',
                    loading: this.loading
                }
            ]
        }
    },
    methods: {
        actionEmitted(action) {
            switch (action) {
                case 'copy':
                    this.copyProm()
                    break
                case 'delete':
                    this.deleteProm()
                    break
            }
        },
        copyProm() {
            this.$copyText(this.selectedPromo.token).then(() => {
                this.$Notif.success('LABEL_COPIED')
            })
        },
        deleteProm() {
            if (this.loading) {
                return
            }
            this.loading = true
            this.$api
                .remove(`v1/vod/codes/${this.selectedPromo.id}`)
                .then(() => {
                    this.$emit('update')
                })
                .catch(error => {
                    this.$Network.handleError(error)
                    this.loading = false
                })
        },
        getProductOptions() {
            return this.$store.getters['content/allProducts'].map(p => {
                return {
                    display: p.title,
                    value: p.uuid
                }
            })
        },
        initDelete() {},
        async submit() {
            if (this.loading) {
                return
            }
            let data = {}
            if (!this.$Utils.setForm(this.promoSection, data, this.errors)) {
                return
            }
            data.discount = parseInt(data.discount)
            data.products = [data.products]
            this.loading = true
            try {
                this.editing
                    ? await this.editPromo(data)
                    : await this.addPromo(data)
                this.$emit('update')
                this.loading = false
            } catch (error) {
                this.$Network.handleError(error, this.errors)
                this.loading = false
            }
        },
        editPromo(data) {
            return this.$api.patch(
                `v1/vod/codes/${this.selectedPromo.id}`,
                data
            )
        },
        addPromo(data) {
            return this.$api.post(`v1/vod/codes`, data)
        },
        close() {
            this.$emit('close')
        },
        setForm() {
            Object.keys(this.selectedPromo).forEach(key => {
                const value = this.selectedPromo[key]
                if (this.promoSection[key]) {
                    switch (key) {
                        case 'products':
                            this.promoSection[key].value = value[0]
                            break
                        default:
                            this.promoSection[key].value = value
                            break
                    }
                }
            })
        }
    },
    mounted() {
        this.setForm()
    }
}
</script>
